import React, { useEffect, useState } from "react";
import { Application } from "@/api/applications";
import { User, ApplicationCustomerUserRoles } from "@/api/users";
import { Role } from "@/api/roles";
import { Customer } from "@/api/customers";
import RigthPanel from "@/ui-controls/RigthPanel";
import NewAppCustomerUserRoleForm from "@/components/roles/appCustomerUserRoles/NewAppCustomerUserRoleForm";

interface Props {
  application: Application | undefined;
  customer: Customer | undefined;
  user: User | undefined;
  appRoles: Role[];
  unassignedAppRoles: Role[];
  isPanelOpenned: boolean;
  onAddApplicationCustomerUserRole?: (
    applicationCustomerUserRoles: ApplicationCustomerUserRoles
  ) => any;
  onPanelClosed?: () => any;
}

const NewAppCustomerUserRolePanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  return (
    <>
      <RigthPanel
        header="Assign Role"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewAppCustomerUserRoleForm}
        childProps={{
          application: props.application,
          customer: props.customer,
          user: props.user,
          allAppRoles: props.appRoles,
          unassignedAppRoles: props.unassignedAppRoles,
          onClose: () => onClosePanel(),
          onSave: (appCustomerUserRoles: ApplicationCustomerUserRoles) => {
            if (props.onAddApplicationCustomerUserRole)
              props.onAddApplicationCustomerUserRole(appCustomerUserRoles);
            onClosePanel();
          },
        }}
      />
    </>
  );
};

export default NewAppCustomerUserRolePanel;
